export default __webpack_public_path__ + "static/media/css.74d7bcc1.svg";